// extracted by mini-css-extract-plugin
export var loadingShimmer = "_r9-2";
export var messageContent = "_r9-0";
export var messagesScroll = "_r9-1";
export var shimmer = "_r9-3";
export var shimmerW100 = "_r9-4";
export var shimmerW70 = "_r9-8";
export var shimmerW80 = "_r9-7";
export var shimmerW85 = "_r9-6";
export var shimmerW90 = "_r9-5";